module.exports = __webpack_public_path__ + "static/media/brochure.71bc8e45.png";